import covid from '../src/assets/images/covid.jpeg';
import dulce from '../src/assets/images/dulce.jpeg';
import DOM from '../src/assets/images/DOM.png';
import poke from '../src/assets/images/poke.png'
import vased from '../src/assets/images/VASED.png';

export const projects = [
    {
        id: 1,
        img: covid,
        link: 'https://quirky-engelbart-595483.netlify.app/',
    },
    {
        id: 2,
        img: dulce,
        link: 'https://dulcejp.netlify.app/',
    },
    {
        id: 3,
        img: DOM,
        link: 'https://wonderful-sinoussi-997a68.netlify.app/',
    },
    {
        id: 4,
        img: poke,
        link: 'https://migcm06.github.io/callin-pokeAPI/',
    },
    {
        id: 5,
        img: vased,
        link: 'https://vased-web.vercel.app/',
    }
  
]